import React, {FC, useState} from 'react'
import {InputDialog, Text, TextButton, TextTypography} from 'wix-ui-tpa/cssVars'

import type {SavedCard} from '../../../../utils/savedCard'
import {getFeeWarningKey} from '../../../../utils/cancellationFeeWarning'
import {cancelModalDataHooks} from '../CancelModal/constants'

import {st, classes} from './styles.st.css'

interface Props {
  t: (key: string, options?: Record<string, unknown>) => string
  isPerGuestFee: boolean
  formattedTotal?: string
  formattedPerGuest?: string
  savedCard?: SavedCard
  guestPolicy?: string | null
  className?: string
  noticeDataHook?: string
  viewPolicyDataHook?: string
}

export const CancellationFeeNotice: FC<Props> = ({
  t,
  isPerGuestFee,
  formattedTotal,
  formattedPerGuest,
  savedCard,
  guestPolicy,
  className,
  noticeDataHook = cancelModalDataHooks.feeNotice(),
  viewPolicyDataHook = cancelModalDataHooks.viewPolicyLink(),
}) => {
  const [isPolicyOpen, setIsPolicyOpen] = useState(false)
  const hasGuestPolicy = Boolean(guestPolicy)
  const viewPolicyLabel = t(
    'uou-reservations.reservation-confirmation.cancel-fee-warning.view-policy',
  )
  const closePolicy = () => setIsPolicyOpen(false)
  const feeWarningKey = getFeeWarningKey(isPerGuestFee, Boolean(savedCard?.last4))

  return (
    <>
      <div className={st(classes.feeNotice, className)} data-hook={noticeDataHook}>
        <Text typography={TextTypography.listText} tagName="p" className={classes.feeNoticeText}>
          {t(feeWarningKey, {
            price: formattedTotal,
            price_per_guest: formattedPerGuest,
            total: formattedTotal,
            perGuest: formattedPerGuest,
            cardBrand: savedCard?.brand,
            last4: savedCard?.last4,
          })}{' '}
          {hasGuestPolicy ? (
            <TextButton
              className={classes.viewPolicyLink}
              onClick={() => setIsPolicyOpen(true)}
              data-hook={viewPolicyDataHook}
            >
              {viewPolicyLabel}
            </TextButton>
          ) : null}
        </Text>
      </div>
      {hasGuestPolicy ? (
        <InputDialog
          isOpen={isPolicyOpen}
          onClose={closePolicy}
          title={viewPolicyLabel}
          closeButtonAriaLabel={t('uou-reservations.shared.modal-close-button')}
          primaryButton={{
            text: t('uou-reservations.reservation-details.terms-privacy.close'),
            onClick: closePolicy,
          }}
          forceBWTheme
          className={classes.policyDialog}
        >
          <Text tagName="p" className={classes.dialogContent}>
            {guestPolicy}
          </Text>
        </InputDialog>
      ) : null}
    </>
  )
}

export default CancellationFeeNotice
